module.exports = __webpack_public_path__ + "img/7-2.8defcb9c.jpg";